/* Rheinkauf – eigener Cookie-Hinweis (Stand 05.10.2026, nach WSTND sections/wstnd-utils.liquid)
 *
 * - Kategorien: Unbedingt erforderlich (immer aktiv) · Präferenzen (u. a. zuletzt angesehene
 *   Artikel) · Statistik · Marketing. Optionale Kategorien sind anfangs nicht angehakt.
 * - Knöpfe „Alle ablehnen“ · „Alle akzeptieren“ · „Auswahl speichern“ – gleich groß, gleich gestaltet.
 * - Erster Besuch: Leiste unten (nicht modal, steht im Dokument ganz vorn, damit Tastatur und
 *   Screenreader sie zuerst erreichen). Erklärungen der Kategorien aufklappbar.
 * - Jeder Link auf #cookie-einstellungen (auch /seite#cookie-einstellungen) und jedes Element mit
 *   data-rk-cookie-oeffnen (alt: data-rk-cookie-settings) öffnet die Einstellungen als Fenster
 *   (delegierter Klick, C1). Ebenso beim Laden bzw. Wechsel auf die Adresse …#cookie-einstellungen.
 *   Den Link „Cookie-Einstellungen“ rendert die Fußzeile selbst (sections/footer.liquid, Paket F2) –
 *   hier wird nichts mehr in die Fußzeile eingefügt.
 * - Gespeichert wird ausschließlich über Shopifys Customer Privacy API (setTrackingConsent).
 *   „Zuletzt angesehen“ (Paket D) hängt an „Präferenzen“.
 * - Google Consent Mode / Tag Manager (layout/theme.liquid, window.rkEinwilligung) bekommt die
 *   AUSDRÜCKLICHE Auswahl: beim Seitenaufruf die gespeicherte, danach jede neue. Ohne Entscheidung
 *   bleibt alles auf „denied“ – auch dann, wenn Shopify in der Region keine Einwilligung verlangt.
 * - Im Browser steht nur, DASS entschieden wurde (localStorage rk_cookie_entschieden), nie WAS.
 * - Andere Overlays warten: html.rk-cookie-offen, Ereignis rk:cookie-entschieden
 *   (assets/newsletter-popup.js).
 */
(function () {
  'use strict';

  var T = {
    leisteTitel: 'Cookies und Ihre Auswahl',
    fensterTitel: 'Cookie-Einstellungen',
    text:
      'Einige Cookies braucht der Shop, damit Warenkorb, Kasse und Kundenkonto funktionieren. ' +
      'Alles Weitere setzen wir nur ein, wenn Sie einverstanden sind. Ihre Auswahl können Sie ' +
      'jederzeit über „Cookie-Einstellungen“ unten auf jeder Seite ändern oder widerrufen.',
    policy: 'Datenschutzerklärung',
    details: 'Was bedeuten die Kategorien?',
    ablehnen: 'Alle ablehnen',
    akzeptieren: 'Alle akzeptieren',
    speichern: 'Auswahl speichern',
    schliessen: 'Schließen',
    immer: 'immer aktiv',
    gespeichert: 'Ihre Auswahl ist gespeichert.',
    fehler: 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.',
    gruppen: [
      {
        key: 'necessary',
        name: 'Unbedingt erforderlich',
        desc: 'Für Warenkorb, Kasse, Kundenkonto, die Sicherheit des Shops und das Speichern Ihrer Cookie-Auswahl.',
        fest: true
      },
      {
        key: 'preferences',
        name: 'Präferenzen',
        desc: 'Funktionen, die sich Ihre Auswahl merken, zum Beispiel zuletzt angesehene Artikel.'
      },
      {
        key: 'analytics',
        name: 'Statistik',
        desc: 'Messung, wie unser Shop genutzt wird, damit wir ihn verbessern können.'
      },
      {
        key: 'marketing',
        name: 'Marketing',
        desc: 'Erfolgsmessung unserer Werbung und passende Werbung auf anderen Plattformen.'
      }
    ]
  };

  var MARK = 'rk_cookie_entschieden';
  var MARK_TAGE = 180;
  var SELEKTOR = 'a[href$="#cookie-einstellungen"], [data-rk-cookie-oeffnen], [data-rk-cookie-settings]';
  var HASH = '#cookie-einstellungen';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var POLICY_URL = (ROOT + '/policies/privacy-policy').replace(/\/{2,}/g, '/');

  var cp = null;
  var leiste = null;
  var fenster = null;
  var zuletzt = null;
  var nr = 0;

  /* ---------- Hilfen ---------- */

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function merken() {
    try { window.localStorage.setItem(MARK, String(Date.now())); } catch (e) { /* privates Fenster */ }
  }

  function gemerkt() {
    try {
      var t = parseInt(window.localStorage.getItem(MARK), 10);
      return !!t && (Date.now() - t) < MARK_TAGE * 86400000;
    } catch (e) { return false; }
  }

  /* Shopify liefert je nach Version 'yes'/'no'/'' oder true/false – auf eine Form bringen */
  function stand() {
    var aus = { analytics: '', marketing: '', preferences: '' };
    var v;
    try { v = cp.currentVisitorConsent() || {}; } catch (e) { return aus; }
    Object.keys(aus).forEach(function (k) {
      var x = v[k];
      if (x === true || x === 'yes') aus[k] = 'yes';
      else if (x === false || x === 'no') aus[k] = 'no';
    });
    return aus;
  }

  function entschieden() {
    var c = stand();
    return c.analytics !== '' || c.marketing !== '' || c.preferences !== '';
  }

  /* Auswahl an Google Consent Mode / Tag Manager weitergeben (layout/theme.liquid).
     Erlaubt ist eine Kategorie nur, wenn sie ausdrücklich gewählt wurde ('yes') UND Shopifys API sie
     erlaubt (analyticsProcessingAllowed, marketingAllowed, preferencesProcessingAllowed). */
  function weitergeben() {
    if (!cp || typeof window.rkEinwilligung !== 'function') return;
    var c = stand();
    function api(name) {
      try { return typeof cp[name] === 'function' ? !!cp[name]() : true; } catch (e) { return false; }
    }
    try {
      window.rkEinwilligung(
        c.analytics === 'yes' && api('analyticsProcessingAllowed'),
        c.marketing === 'yes' && api('marketingAllowed'),
        c.preferences === 'yes' && api('preferencesProcessingAllowed')
      );
    } catch (e) { /* Consent Mode nicht vorhanden: nichts zu tun */ }
  }

  function fokusierbare(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary'),
      function (el) { return el.getClientRects().length > 0; }
    );
  }

  function mitApi(cb) {
    if (cp) { cb(cp); return; }
    var S = window.Shopify;
    if (S && S.customerPrivacy) { cp = S.customerPrivacy; cb(cp); return; }
    if (S && typeof S.loadFeatures === 'function') {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          cp = !error && window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
          cb(cp);
        });
      } catch (e) { cb(null); }
      return;
    }
    cb(null);
  }

  /* ---------- Zustimmung schreiben ---------- */

  function speichern(werte, fertig) {
    if (!cp) { fertig(false); return; }
    var payload = {
      analytics: !!werte.analytics,
      marketing: !!werte.marketing,
      preferences: !!werte.preferences,
      sale_of_data: !!werte.marketing
    };
    var erledigt = false;
    function ende(ok) {
      if (erledigt) return;
      erledigt = true;
      if (ok) merken();
      fertig(ok);
    }
    function passt() {
      var c = stand();
      return ['analytics', 'marketing', 'preferences'].every(function (k) {
        return c[k] === (payload[k] ? 'yes' : 'no');
      });
    }
    try {
      cp.setTrackingConsent(payload, function (antwort) {
        ende(!(antwort && antwort.error));
      });
      /* Bleibt die Rückmeldung aus: gespeicherten Stand prüfen statt Erfolg zu behaupten */
      setTimeout(function () { ende(passt()); }, 4000);
    } catch (e) {
      ende(false);
    }
  }

  /* ---------- Markup (Leiste und Fenster gleich aufgebaut) ---------- */

  function bauen(modus) {
    nr += 1;
    var id = 'rk-cookie-' + modus + '-' + nr;
    var c = stand();
    var zeilen = T.gruppen.map(function (g) {
      var an = g.fest ? true : c[g.key] === 'yes';
      var feldId = id + '-' + g.key;
      return '' +
        '<li class="rk-cookie__zeile">' +
          '<input type="checkbox" id="' + feldId + '"' +
            (g.fest ? ' checked disabled' : ' data-rk-gruppe="' + g.key + '"' + (an ? ' checked' : '')) +
            ' aria-describedby="' + feldId + '-text">' +
          '<label for="' + feldId + '"><span class="rk-cookie__name">' + esc(g.name) + '</span>' +
            (g.fest ? ' <span class="rk-cookie__immer">(' + esc(T.immer) + ')</span>' : '') +
          '</label>' +
          '<p class="rk-cookie__erkl" id="' + feldId + '-text">' + esc(g.desc) + '</p>' +
        '</li>';
    }).join('');

    var liste = '<ul class="rk-cookie__liste" role="list">' + zeilen + '</ul>';
    /* Leiste: kurze Liste, Erklärungen aufklappbar. Fenster: Erklärungen direkt unter jeder Kategorie. */
    var erklaerung = '<details class="rk-cookie__details"><summary>' + esc(T.details) + '</summary><dl class="rk-cookie__dl">' +
      T.gruppen.map(function (g) {
        return '<dt>' + esc(g.name) + (g.fest ? ' (' + esc(T.immer) + ')' : '') + '</dt><dd>' + esc(g.desc) + '</dd>';
      }).join('') + '</dl></details>';
    var inhalt = '<fieldset class="rk-cookie__gruppen"><legend class="rk-cookie__legende">Welche Cookies dürfen wir verwenden?</legend>' +
      liste + (modus === 'leiste' ? erklaerung : '') + '</fieldset>';

    var n = document.createElement('div');
    n.className = 'rk-cookie rk-cookie--' + modus;
    n.innerHTML =
      (modus === 'fenster' ? '<div class="rk-cookie__schleier" data-rk-zu></div>' : '') +
      '<div class="rk-cookie__box"' +
        (modus === 'fenster'
          ? ' role="dialog" aria-modal="true" aria-labelledby="' + id + '-titel" aria-describedby="' + id + '-text"'
          : ' role="region" aria-labelledby="' + id + '-titel"') +
        ' tabindex="-1">' +
        (modus === 'fenster'
          ? '<button type="button" class="rk-cookie__x" data-rk-zu aria-label="' + esc(T.schliessen) + '">' +
              '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>'
          : '') +
        '<h2 class="rk-cookie__titel" id="' + id + '-titel">' + esc(modus === 'fenster' ? T.fensterTitel : T.leisteTitel) + '</h2>' +
        '<p class="rk-cookie__text" id="' + id + '-text">' + esc(T.text) + ' <a href="' + POLICY_URL + '">' + esc(T.policy) + '</a></p>' +
        inhalt +
        '<div class="rk-cookie__knoepfe">' +
          '<button type="button" class="rk-cookie__knopf" data-rk-aktion="ablehnen">' + esc(T.ablehnen) + '</button>' +
          '<button type="button" class="rk-cookie__knopf" data-rk-aktion="akzeptieren">' + esc(T.akzeptieren) + '</button>' +
          '<button type="button" class="rk-cookie__knopf" data-rk-aktion="speichern">' + esc(T.speichern) + '</button>' +
        '</div>' +
        '<p class="rk-cookie__status" role="status" aria-live="polite"></p>' +
      '</div>';

    n.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-rk-zu]')) { fensterZu(); return; }
      var knopf = t.closest('[data-rk-aktion]');
      if (!knopf) return;
      var aktion = knopf.getAttribute('data-rk-aktion');
      var werte = {};
      Array.prototype.forEach.call(n.querySelectorAll('[data-rk-gruppe]'), function (box) {
        if (aktion === 'ablehnen') box.checked = false;
        if (aktion === 'akzeptieren') box.checked = true;
        werte[box.getAttribute('data-rk-gruppe')] = box.checked;
      });
      fertigMelden(n, '');
      Array.prototype.forEach.call(n.querySelectorAll('[data-rk-aktion]'), function (b) { b.disabled = true; });
      speichern(werte, function (ok) {
        Array.prototype.forEach.call(n.querySelectorAll('[data-rk-aktion]'), function (b) { b.disabled = false; });
        if (!ok) { fertigMelden(n, T.fehler); return; }
        weitergeben();
        if (modus === 'fenster') {
          fertigMelden(n, T.gespeichert);
          setTimeout(fensterZu, 700);
        }
        leisteZu();
      });
    });
    return n;
  }

  function fertigMelden(n, text) {
    var s = n.querySelector('.rk-cookie__status');
    if (s) s.textContent = text || '';
  }

  /* ---------- Leiste ---------- */

  function leisteAuf() {
    if (leiste) return;
    leiste = bauen('leiste');
    leiste.id = 'rk-cookie';
    document.body.insertBefore(leiste, document.body.firstChild);
    document.documentElement.classList.add('rk-cookie-offen');
    window.requestAnimationFrame(function () { if (leiste) leiste.classList.add('is-offen'); });
  }

  function leisteZu() {
    if (!leiste) return;
    var n = leiste;
    leiste = null;
    n.classList.remove('is-offen');
    document.documentElement.classList.remove('rk-cookie-offen');
    try { document.dispatchEvent(new CustomEvent('rk:cookie-entschieden')); } catch (e) { /* alte Browser */ }
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 300);
  }

  /* ---------- Fenster ---------- */

  function tasten(e) {
    if (!fenster) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      fensterZu();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = fokusierbare(fenster.querySelector('.rk-cookie__box'));
    if (!f.length) return;
    var erst = f[0];
    var letzt = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === erst || !fenster.contains(document.activeElement))) {
      e.preventDefault();
      letzt.focus();
    } else if (!e.shiftKey && document.activeElement === letzt) {
      e.preventDefault();
      erst.focus();
    }
  }

  function fensterAuf() {
    if (fenster) return;
    zuletzt = document.activeElement;
    fenster = bauen('fenster');
    fenster.id = 'rk-cookie-prefs';
    document.body.appendChild(fenster);
    document.documentElement.classList.add('rk-cookie-fenster-offen');
    window.requestAnimationFrame(function () { if (fenster) fenster.classList.add('is-offen'); });
    var box = fenster.querySelector('.rk-cookie__box');
    if (box) box.focus();
    document.addEventListener('keydown', tasten, true);
  }

  function fensterZu() {
    if (!fenster) return;
    document.removeEventListener('keydown', tasten, true);
    var n = fenster;
    fenster = null;
    n.classList.remove('is-offen');
    document.documentElement.classList.remove('rk-cookie-fenster-offen');
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 220);
    if (zuletzt && zuletzt.focus && document.contains(zuletzt)) {
      zuletzt.focus();
    } else if (leiste) {
      var b = leiste.querySelector('.rk-cookie__box');
      if (b) b.focus();
    }
    zuletzt = null;
  }

  function einstellungenOeffnen() {
    mitApi(function (api) {
      if (api) { fensterAuf(); } else { window.location.href = POLICY_URL; }
    });
  }

  /* ---------- Start ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(SELEKTOR) : null;
    if (!t) return;
    e.preventDefault();
    einstellungenOeffnen();
  });

  /* Adresse …#cookie-einstellungen (z. B. Link von einer anderen Seite) öffnet die Einstellungen */
  window.addEventListener('hashchange', function () {
    if (window.location.hash === HASH) einstellungenOeffnen();
  });

  /* Auswahl über eine andere Shopify-Oberfläche: Stand neu lesen und weitergeben */
  document.addEventListener('visitorConsentCollected', function () {
    setTimeout(weitergeben, 0);
  });

  function start() {
    if (window.location.hash === HASH) {
      setTimeout(einstellungenOeffnen, 300);
    }
    mitApi(function (api) {
      if (!api) return;
      weitergeben();
      /* Diagnose für die Prüfung im Browser (window.__rkCookie) */
      window.__rkCookie = { zustimmung: stand(), gemerkt: gemerkt() };
      try { window.__rkCookie.shouldShowBanner = api.shouldShowBanner(); } catch (e) { /* ältere API */ }
      /* Die Leiste erscheint genau dann, wenn noch keine Entscheidung vorliegt. */
      if (!entschieden() && !gemerkt()) leisteAuf();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
